<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Dashboard") }}:</h3>
        <p>{{ currentDate() }}</p>
        <div
          v-if="
            usertype === USER_TYPE.ADMIN || usertype === USER_TYPE.ENTERPRISE
          "
          class="md-toolbar-section-end"
        >
          <md-button v-if="filterShow" @click="filterOff()" class="md-primary">
            <md-icon>filter_alt_off</md-icon>
          </md-button>
          <md-button
            v-else-if="!filterShow"
            @click="filterOn()"
            class="md-primary"
          >
            <md-icon>filter_alt</md-icon>
          </md-button>
        </div>
      </md-toolbar>
      <br />
    </div>

    <div
      v-if="
        (usertype === USER_TYPE.ADMIN || usertype === USER_TYPE.ENTERPRISE) &&
          (dt_startDate === null || dt_endDate === null) &&
          filterShow
      "
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <div class="md-layout">
        <div
          class="md-layout-item md-small-hide md-size-40"
          style="padding-left: 100px;"
        >
          <p class="">
            {{ $t("Filter Data") }}: &nbsp;
            {{
              $t("Please select date range then click 'GO' to filter data")
            }}&nbsp;
          </p>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-20">
          <md-datepicker disabled v-model="startDate" md-immediately>
            <label>{{ $t("Select From date") }}</label>
          </md-datepicker>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-20">
          <md-datepicker v-model="endDate" md-immediately>
            <label>{{ $t("Select To date") }}</label>
          </md-datepicker>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-10">
          <md-button class="md-primary" @click="filterData()">
            {{ $t("GO") }}
          </md-button>
        </div>
      </div>
    </div>
    <div
      v-if="
        (usertype === USER_TYPE.ADMIN || usertype === USER_TYPE.ENTERPRISE) &&
          (dt_startDate !== null || dt_endDate !== null) &&
          filterShow
      "
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <div class="md-layout">
        <div
          class="md-layout-item md-small-hide md-size-50"
          style="padding-left: 100px;"
        >
          <p class="">
            {{ $t("Filtered Data") }}: &nbsp; {{ $t("From") }}:
            {{ dt_startDate }}&nbsp; &nbsp; {{ $t("To") }}:
            {{ dt_endDate }} &nbsp;
          </p>
        </div>
        <div class="md-layout-item md-small-hide md-size-30">
          &nbsp;
        </div>
        <div class="md-layout-item md-small-size-100 md-size-10">
          <md-button class="md-primary" @click="resetDate()">
            {{ $t("Reset") }}
          </md-button>
        </div>
      </div>
    </div>

    <div
      v-if="usertype === USER_TYPE.PILOT"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Pilot Summary") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            table-header-color="primary"
            class="paginated-table table-striped table-hover"
          >
            <md-table-head>{{ $t("Name") }}</md-table-head>
            <md-table-head>{{ $t("Certificate No.") }}</md-table-head>
            <md-table-head v-if="usertype !== USER_TYPE.FREE">
              {{ $t("Missions (Created)") }}
              <md-tooltip md-direction="top">
                {{ $t("Number of total recorded flights") }}
              </md-tooltip>
            </md-table-head>

            <md-table-head v-if="usertype !== USER_TYPE.FREE">
              {{ $t("Missions (Completed)") }}
              <md-tooltip md-direction="top">
                {{ $t("Number of completed flights") }}
              </md-tooltip>
            </md-table-head>
            <md-table-head v-if="usertype !== USER_TYPE.FREE">
              {{ $t("Flight Hours (Logged)") }}
            </md-table-head>

            <md-table-row v-for="(item, position) in pilots" :key="position">
              <md-table-cell
                v-if="item.pilot && email === item.email"
                :md-label="$t('Name')"
              >
                {{ item.firstname }} {{ item.lastname }}
              </md-table-cell>

              <md-table-cell
                v-if="item.pilot && email === item.email"
                :md-label="$t('License Number')"
              >
                <label style="line-height: 52px">{{ item.license }}</label>
                <md-button
                  class="md-just-icon md-simple md-primary"
                  v-if="item.licenseFile"
                >
                  <a target="blank" :href="LICENSE_URL + item.licenseFile">
                    <md-icon>visibility</md-icon>
                  </a>
                </md-button>
              </md-table-cell>

              <md-table-cell
                :md-label="$t('Total (days)')"
                v-if="
                  usertype !== USER_TYPE.FREE &&
                    item.pilot &&
                    pilotHasAllMissions &&
                    email === item.email
                "
                >{{
                  item.pilot &&
                  pilotTotalMissionsAll &&
                  pilotTotalMissionsAll.find(
                    pilot => pilot._id.license === item.license
                  )
                    ? pilotTotalMissionsAll.find(
                        pilot => pilot._id.license === item.license
                      ).missions
                    : item.license
                    ? 0
                    : ""
                }}</md-table-cell
              >
              <md-table-cell
                :md-label="$t('Total (days)')"
                v-else-if="
                  usertype !== USER_TYPE.FREE &&
                    item.pilot &&
                    !pilotHasAllMissions &&
                    email === item.email
                "
                >{{ 0 }}</md-table-cell
              >

              <md-table-cell
                :md-label="$t('Total (days)')"
                v-if="
                  usertype !== USER_TYPE.FREE &&
                    item.pilot &&
                    pilotHasMissions &&
                    email === item.email
                "
                >{{
                  item.pilot &&
                  pilotTotalMissions &&
                  pilotTotalMissions.find(
                    pilot => pilot._id.license === item.license
                  )
                    ? pilotTotalMissions.find(
                        pilot => pilot._id.license === item.license
                      ).missions
                    : item.license
                    ? 0
                    : ""
                }}</md-table-cell
              >
              <md-table-cell
                :md-label="$t('Total (days)')"
                v-else-if="
                  usertype !== USER_TYPE.FREE &&
                    item.pilot &&
                    !pilotHasMissions &&
                    email === item.email
                "
                >{{ 0 }}</md-table-cell
              >

              <md-table-cell
                :md-label="$t('Total (hours)')"
                v-if="
                  usertype !== USER_TYPE.FREE &&
                    item.pilot &&
                    pilotHasHours &&
                    email === item.email
                "
                >{{
                  item.pilot &&
                  pilotTotalHours &&
                  pilotTotalHours.find(
                    pilot => pilot._id.license === item.license
                  )
                    ? pilotTotalHours
                        .find(pilot => pilot._id.license === item.license)
                        .hours.toFixed(2)
                    : item.license
                    ? (0.0).toFixed(2)
                    : ""
                }}</md-table-cell
              >
              <md-table-cell
                :md-label="$t('Total (hours)')"
                v-else-if="
                  usertype !== USER_TYPE.FREE &&
                    item.pilot &&
                    !pilotHasHours &&
                    email === item.email
                "
                >{{ (0.0).toFixed(2) }}</md-table-cell
              >
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <div
      v-else
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Pilot Summary") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            table-header-color="primary"
            class="paginated-table table-striped table-hover"
          >
            <md-table-head>{{ $t("Name") }}</md-table-head>
            <md-table-head>{{ $t("Certificate No.") }}</md-table-head>
            <md-table-head v-if="usertype !== USER_TYPE.FREE">
              {{ $t("Missions (Created)") }}
              <md-tooltip md-direction="top">
                {{ $t("Number of total recorded flights") }}
              </md-tooltip>
            </md-table-head>
            <md-table-head v-if="usertype !== USER_TYPE.FREE">
              {{ $t("Missions (Completed)") }}
              <md-tooltip md-direction="top">
                {{ $t("Number of completed flights") }}
              </md-tooltip>
            </md-table-head>
            <md-table-head v-if="usertype !== USER_TYPE.FREE">
              {{ $t("Flight Hours (Logged)") }}
            </md-table-head>

            <md-table-row v-for="(item, position) in pilots" :key="position">
              <md-table-cell v-if="item.pilot" :md-label="$t('Name')">
                {{ item.firstname }} {{ item.lastname }}
              </md-table-cell>

              <md-table-cell v-if="item.pilot" :md-label="$t('License Number')">
                <label style="line-height: 52px">{{ item.license }}</label>
                <md-button
                  class="md-just-icon md-simple md-primary"
                  v-if="item.licenseFile"
                >
                  <a target="blank" :href="LICENSE_URL + item.licenseFile">
                    <md-icon>visibility</md-icon>
                  </a>
                </md-button>
              </md-table-cell>

              <md-table-cell
                :md-label="$t('Total (days)')"
                v-if="
                  usertype !== USER_TYPE.FREE &&
                    item.pilot &&
                    pilotHasAllMissions
                "
                >{{
                  item.pilot &&
                  pilotTotalMissionsAll &&
                  pilotTotalMissionsAll.find(
                    pilot => pilot._id.license === item.license
                  )
                    ? pilotTotalMissionsAll.find(
                        pilot => pilot._id.license === item.license
                      ).missions
                    : item.license
                    ? 0
                    : ""
                }}</md-table-cell
              >
              <md-table-cell
                :md-label="$t('Total (days)')"
                v-else-if="
                  usertype !== USER_TYPE.FREE &&
                    item.pilot &&
                    !pilotHasAllMissions
                "
                >{{ 0 }}</md-table-cell
              >

              <md-table-cell
                :md-label="$t('Total (days)')"
                v-if="
                  usertype !== USER_TYPE.FREE && item.pilot && pilotHasMissions
                "
                >{{
                  item.pilot &&
                  pilotTotalMissions &&
                  pilotTotalMissions.find(
                    pilot => pilot._id.license === item.license
                  )
                    ? pilotTotalMissions.find(
                        pilot => pilot._id.license === item.license
                      ).missions
                    : item.license
                    ? 0
                    : ""
                }}</md-table-cell
              >
              <md-table-cell
                :md-label="$t('Total (days)')"
                v-else-if="
                  usertype !== USER_TYPE.FREE && item.pilot && !pilotHasMissions
                "
                >{{ 0 }}</md-table-cell
              >

              <md-table-cell
                :md-label="$t('Total (hours)')"
                v-if="
                  usertype !== USER_TYPE.FREE && item.pilot && pilotHasHours
                "
                >{{
                  item.pilot &&
                  pilotTotalHours &&
                  pilotTotalHours.find(
                    pilot => pilot._id.license === item.license
                  )
                    ? pilotTotalHours
                        .find(pilot => pilot._id.license === item.license)
                        .hours.toFixed(2)
                    : item.license
                    ? (0.0).toFixed(2)
                    : ""
                }}</md-table-cell
              >
              <md-table-cell
                :md-label="$t('Total (hours)')"
                v-else-if="
                  usertype !== USER_TYPE.FREE && item.pilot && !pilotHasHours
                "
                >{{ (0.0).toFixed(2) }}</md-table-cell
              >
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("RPAS List") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table class="paginated-table table-striped table-hover">
            <md-table-head>{{ $t("Manufacturer") }}</md-table-head>
            <md-table-head>{{ $t("Model") }}</md-table-head>
            <md-table-head>{{ $t("RPAS Nickname") }}</md-table-head>
            <md-table-head>{{ $t("Registration No.") }}</md-table-head>
            <md-table-head>{{ $t("Colour") }}</md-table-head>

            <md-table-head v-if="usertype !== USER_TYPE.FREE">
              {{ $t("Flight Hours (Logged)") }}
              <md-tooltip md-direction="top">
                {{ $t("Total number of logged flight hours") }}
              </md-tooltip>
            </md-table-head>
            <md-table-row v-for="(item, position) in drones" :key="position">
              <md-table-cell
                :md-label="$t('Manufacturer')"
                v-if="item.manufacturer"
                >{{ item.manufacturer }}</md-table-cell
              >
              <md-table-cell :md-label="$t('Model')" v-if="item.manufacturer">{{
                item.model
              }}</md-table-cell>
              <md-table-cell :md-label="$t('RPAS Nickname')">
                <label style="line-height: 52px">
                  {{ item.nickname }}
                </label>
              </md-table-cell>
              <md-table-cell
                :md-label="$t('Registration Number')"
                v-if="item.manufacturer"
                ><label style="line-height: 52px">{{
                  item.registrationnumber
                }}</label>
                <md-button
                  class="md-just-icon md-simple md-primary"
                  v-if="item.certificateFile"
                >
                  <a
                    target="blank"
                    :href="CERTIFICATE_URL + item.certificateFile"
                  >
                    <md-icon>visibility</md-icon>
                  </a>
                </md-button>
              </md-table-cell>
              <md-table-cell
                :md-label="$t('Colour')"
                v-if="item.manufacturer"
                >{{ item.color }}</md-table-cell
              >

              <md-table-cell
                :md-label="$t('Total (hours)')"
                v-if="
                  usertype !== USER_TYPE.FREE &&
                    droneHasHours &&
                    item.manufacturer
                "
                >{{
                  droneTotalHours &&
                  droneTotalHours.find(
                    drone => drone._id.drone === item.registrationnumber
                  )
                    ? droneTotalHours
                        .find(
                          drone => drone._id.drone === item.registrationnumber
                        )
                        .hours.toFixed(2)
                    : item.registrationnumber
                    ? (0.0).toFixed(2)
                    : ""
                }}</md-table-cell
              >
              <md-table-cell
                :md-label="$t('Total (hours)')"
                v-else-if="
                  usertype !== USER_TYPE.FREE &&
                    !droneHasHours &&
                    item.manufacturer
                "
                >{{ (0.0).toFixed(2) }}</md-table-cell
              >
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card v-if="usertype !== USER_TYPE.FREE">
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Upcoming / In Progress Missions") }}</h4>
          </div>
        </md-card-header>
        <md-card-content v-if="surveys.length > 0">
          <md-table class="paginated-table table-striped table-hover">
            <md-table-head>{{ $t("Date") }}</md-table-head>
            <md-table-head>{{ $t("Mission Name") }}</md-table-head>
            <md-table-head>{{ $t("Pilot") }}</md-table-head>
            <md-table-head>{{ $t("Drone") }}</md-table-head>
            <md-table-head>{{ $t("Location") }}</md-table-head>
            <md-table-head>{{ $t("Airspace") }}</md-table-head>
            <md-table-head>{{ $t("Site Surveys") }}</md-table-head>
            <md-table-row v-for="(item, position) in surveys" :key="position">
              <md-table-cell :md-label="$t('Date')">{{
                item.startTime
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Mission Name')">{{
                item.title
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Pilot')">{{
                item.pilot
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Drone')">{{
                item.manufacturer + " - " + item.rpas
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Location')">{{
                item.address
              }}</md-table-cell>
              <md-table-cell
                :md-label="$t('Airspace')"
                v-if="item.controlled"
                class="text-danger"
                >{{ $t("Controlled") }}</md-table-cell
              >
              <md-table-cell
                :md-label="$t('Airspace')"
                v-else
                class="text-success"
                >{{ $t("Uncontrolled") }}</md-table-cell
              >
              <md-table-cell :md-label="$t('Site Surveys')">
                <md-button
                  class="md-just-icon md-simple md-danger"
                  v-if="item.pdf !== ''"
                >
                  <a target="blank" :href="item.pdf">
                    <md-icon>archive</md-icon>
                  </a>
                </md-button>
                <md-button class="md-just-icon md-simple" v-else>
                  <md-icon>sync</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapMultiRowFields } from "vuex-map-fields";
import swal from "sweetalert2";
import { USER_TYPE } from "@/const.js";
import { EventBus, LICENSE_URL, CERTIFICATE_URL } from "@/helpers";
import moment from "moment";

export default {
  data() {
    return {
      LICENSE_URL: LICENSE_URL,
      CERTIFICATE_URL: CERTIFICATE_URL,
      USER_TYPE: USER_TYPE,
      startDate: null,
      endDate: null,
      dt_startDate: null,
      dt_endDate: null,
      startTime: null,
      endTime: null,
      filterUsed: false,
      filterShow: false
    };
  },
  computed: {
    ...mapMultiRowFields("stats", ["droneCurrentHours", "droneTotalHours"]),
    ...mapMultiRowFields("stats", [
      "pilotTotalMissions",
      "pilotTotalMissionsAll",
      "pilotTotalHours",
      "pilotCurrentDays"
    ]),
    ...mapMultiRowFields("setting", ["drones", "pilots", "pilotTraining"]),
    ...mapFields("auth", [
      "email",
      "usertype",
      "quantity",
      "plan_type",
      "cancelled",
      "registered_on",
      "current_period_start_date",
      "current_period_end_date"
    ]),
    ...mapFields("stats", [
      "freeTrial",
      "missionLabels",
      "missionSeries",
      "maxMissionCount",
      "pilotLabels",
      "pilotSeries",
      "maxPilotCount",
      "droneLabels",
      "droneSeries",
      "maxDroneCount",
      "totalMissions",
      "totalHours",
      "pilotHasMissions",
      "pilotHasAllMissions",
      "pilotHasHours",
      "droneHasHours"
    ]),
    ...mapMultiRowFields("survey", ["surveys"])
  },
  methods: {
    currentDate() {
      const current = new Date();
      const date = moment(current).format("MMMM DD, YYYY");
      return date;
    },
    filterOn() {
      this.filterShow = true;
    },
    filterOff() {
      this.resetDate();
      this.filterShow = false;
    },
    filterData() {
      this.filterUsed = true;
      this.dt_startDate = moment(this.startDate).format("MMMM DD, YYYY");
      this.dt_endDate = moment(this.endDate).format("MMMM DD, YYYY");
      this.startDate.setHours(23, 59, 59, 999);
      this.endDate.setHours(23, 59, 59, 999);
      this.endDate.setDate(this.endDate.getDate() + 1);
      this.startTime = Math.floor(this.startDate.getTime() / 1000);
      this.endTime = Math.floor(this.endDate.getTime() / 1000);
      if (this.endTime < this.startTime) {
        swal.fire({
          title: this.$t("Error"),
          text: this.$t("To date cannot be earlier than from date."),
          type: "error",
          confirmButtonClass: "md-button md-error",
          buttonsStyling: false
        });
        this.resetDate();
      } else {
        this.$store.dispatch("stats/getPilotRangeTotalMissionsAll", {
          startTime: this.startTime,
          endTime: this.endTime
        });

        this.$store.dispatch("stats/getPilotRangeTotalMissions", {
          startTime: this.startTime,
          endTime: this.endTime
        });

        this.$store.dispatch("stats/getPilotRangeTotalHours", {
          startTime: this.startTime,
          endTime: this.endTime
        });

        this.$store.dispatch("stats/getDroneRangeTotalHours", {
          startTime: this.startTime,
          endTime: this.endTime
        });
      }
    },
    resetDate() {
      this.startDate = null;
      this.endDate = null;
      this.dt_startDate = null;
      this.dt_endDate = null;
      this.startTime = null;
      this.endTime = null;
      this.$store.dispatch("stats/getPilotTotalMissionsAll");
      this.$store.dispatch("stats/getPilotTotalMissions");
      this.$store.dispatch("stats/getPilotTotalHours");
      this.$store.dispatch("stats/getDroneTotalHours");
    }
  },
  beforeMount() {
    this.$store.dispatch("setting/getSettings");
    this.$store.dispatch("survey/getSurveys", {
      type: "new",
      currentPage: 1,
      perPage: 5
    });
    this.$store.dispatch("survey/getSMS");
    this.$store.dispatch("subscription/retrieveSubscription");
    //this.$store.dispatch("stats/getMilestone");
    this.$store.dispatch("stats/getPilotTotalMissionsAll");
    this.$store.dispatch("stats/getPilotTotalMissions");
    this.$store.dispatch("stats/getPilotTotalHours");
    this.$store.dispatch("stats/getDroneCurrentHours");
    this.$store.dispatch("stats/getPilotCurrentDays");
    this.$store.dispatch("stats/getDroneTotalHours");
    //this.freeTrial = 8 - this.maxSurveyCount;
  },
  mounted() {
    this.$store.dispatch("drone/getDroneOptions");
    this.$store.dispatch("subscription/getPlans");
    this.$store.dispatch("stats/getPilotTotalMissionsAll");
    this.$store.dispatch("stats/getPilotTotalMissions");
    this.$store.dispatch("stats/getPilotTotalHours");
    this.$store.dispatch("stats/getDroneTotalHours");
  },
  beforeDestroy() {
    //EventBus.$off("setMilestone");
    EventBus.$off("setSubscription");
  }
};
</script>
<style lang="css">
.md-toolbar {
  background-color: #0abab5;
}

.md-datepicker-header .md-datepicker-year-select {
  color: white;
  cursor: pointer;
  opacity: 0.54;
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 24px;
}
</style>
